import type { UseMutationResult } from "@tanstack/react-query"

import { useSolarConcertStatusCommand } from "./solar-concert-application-cache"
import type { SolarConcertApplicationStatusDto } from "../dto/solar-concert.dto"
import { solarProposalService } from "../services/solar-proposal.service"

/** Send every uploaded stipulation document to Concert for underwriting review. */
export default function useSubmitSolarConcertDocuments(): UseMutationResult<
  SolarConcertApplicationStatusDto,
  unknown,
  { proposalId: string }
> {
  return useSolarConcertStatusCommand(({ proposalId }) =>
    solarProposalService.submitConcertDocumentsForReview(proposalId),
  )
}
